import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AppService } from '../../../app.service';
import { Subscription } from 'rxjs/Subscription';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CurrencyViewModel, LanguageViewModel, UserPreferencesViewModel } from './preferences.model';
import { GETPreferencesService } from './preferences.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
    selector: 'app-preferences',
    templateUrl: './preferences.component.html',
    styleUrls: ['./preferences.component.scss']
})
export class PreferencesComponent implements OnInit {
    private subscriptions: Subscription[] = [];
    currencies: CurrencyViewModel[] = [];
    languages: LanguageViewModel[] = [];
    preferences: UserPreferencesViewModel = new UserPreferencesViewModel();
    selectedUOM: number = 0;

    constructor(private _appService: AppService,
        private _pref: GETPreferencesService,
        public toastr: NotificationsService, vcr: ViewContainerRef) {
        
    }

    ngOnInit() {
        this._appService.setPageTitle("User Preferences");
       // this._appService.setPageSubTitle("On this page you can configure the language, currency, unit of measurement and contact details for your user.");
        this.loadAllData();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => { if (!s.closed) s.unsubscribe() });
    }

    loadAllData() {
        let pref_currencies = this._pref.getAllCurrencies();
        let pref_languages = this._pref.getAllLanguages();
        let pref_general = this._pref.getUserPreferences();

        this.subscriptions.push(forkJoin(pref_currencies, pref_languages, pref_general).subscribe(r => {
            this.currencies = r[0];
            this.languages = r[1];
            this.preferences = r[2];
            if (this.preferences.UnitOfMeasurementName == "mm") {
                this.selectedUOM = 2;
            } else if (this.preferences.UnitOfMeasurementName == "inch") {
                this.selectedUOM = 1;
            }

        }, error => {
            console.error(error);
        }));
    }

    changeUOM(val: number) {
        if (val == 1) {
            this.preferences.UnitOfMeasurementName = "inch";
        } else {
            this.preferences.UnitOfMeasurementName = "mm";
        }
    }

    submitChanges() {
        this._pref.saveUserPreferences(this.preferences).subscribe(r => {
            if (r.m_Item1) {
                this.toastr.success(r.m_Item2)
            } else {
                this.toastr.error(r.m_Item2);
            }
        });
    }

    doNothing() {

    }
}
